module.exports = __webpack_public_path__ + "img/quick-trip.6a3b0f71.svg";